import { makeRequest } from "./api";

export const FetchHouseTypes = async () => {
  return makeRequest("/api/admin/propertyType/fetch");
};

export const CreateHouseType = async (formData) => {
  return makeRequest("/api/admin/propertyType/create", {
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const UpdateHouseType = async (formData) => {
  return makeRequest(`/api/admin/propertyType/update`, {
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const DeleteHouseType = async (houseTypeId) => {
  return makeRequest(`/api/admin/propertyType/remove/${houseTypeId}`, {
    method: "DELETE",
  });
};
